const initialState = {
  model: null,
  location: null,
  stakeholder: null,
  errorMessageHTML: null,
  successMessageHTML: null,
};

export default function reducer(
  state = {
    ...initialState
  },
  action
) {
  switch (action.type) {
    case "SET_ACTION":
      return {
        ...initialState,
        model: action.data,
      };

    case "FETCH_ACTIONS":
      return {
        ...state,
        errorMessageHTML: null,
        successMessageHTML: null,
      };

    case "TAKE_ACTION_FULFILLED":
      return {
        ...initialState,
        successMessageHTML: action.data.message,
        errorMessageHTML: null,
      };

    case "TAKE_ACTION_REJECTED":
      return {
        ...initialState,
        errorMessageHTML: action.data,
        successMessageHTML: null,
      };

    case "RESET":
    case "LOGOUT":
      return {
        ...initialState,
      };

    default:
      return state;
  }
}
